export const CUSTOM_ITEMS = [
  {
    name: "Inteiro",
    key_: "int",
    applicationName: "CUSTOM",
  },
  {
    name: "Float",
    key_: "float",
    applicationName: "CUSTOM",
  },
  {
    name: "Boleano",
    key_: "boolean",
    applicationName: "CUSTOM",
  },
];
